import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const StyledTypography = styled(Typography)(({ theme, type }) => ({
    fontFamily: 'Open Sans',
    color: 'var(--ahg-waterloo-darken1)'
}));
